import { Component, Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import CommandCenter from "@/pages/CommandCenter";
import NotFound from "@/pages/NotFound";
import { Skeleton } from "@/components/shared";

const NewTest = lazy(() => import("@/pages/NewTest"));
const Arena = lazy(() => import("@/pages/Arena"));
const Report = lazy(() => import("@/pages/Report"));
const History = lazy(() => import("@/pages/History"));
const ExportReport = lazy(() => import("@/pages/ExportReport"));

class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return <NotFound title="Something broke" message={String(this.state.error?.message || this.state.error)}
        action={<button className="btn-primary" onClick={() => { this.setState({ error: null }); window.location.reload(); }} data-testid="error-reload">Reload</button>} />;
    }
    return this.props.children;
  }
}

const PageFallback = () => (
  <div className="space-y-6" aria-busy="true"><Skeleton className="h-10 w-72" /><div className="grid grid-cols-2 lg:grid-cols-4 gap-4">{[0, 1, 2, 3].map((i) => <Skeleton key={i} className="h-28" />)}</div><Skeleton className="h-72" /></div>
);

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<div className="p-10"><PageFallback /></div>}>
          <Routes>
            <Route path="/report/:id/export" element={<ExportReport />} />
            <Route element={<Layout />}>
              <Route index element={<CommandCenter />} />
              <Route path="/new" element={<NewTest />} />
              <Route path="/arena/:id" element={<Arena />} />
              <Route path="/tests/:id/report" element={<Report />} />
              <Route path="/report/:id" element={<Report readOnly />} />
              <Route path="/history" element={<History />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </ErrorBoundary>
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}
